import { useMemo } from 'react';
import * as Yup from 'yup';

const useValidationSchema = (formItems, isBlocks) => {
  const addValidation = (obj, item) => {
    if (Array.isArray(item)) {
      item.forEach(subItem => addValidation(obj, subItem));
    } else {
      if (item.validation) obj[item.name] = item.validation;
    }
  };

  return useMemo(() => {
    const schema = formItems.reduce((obj, item) => {
      if (isBlocks) {
        item.items.forEach(subItem => {
          addValidation(obj, subItem);
        });
      } else {
        addValidation(obj, item);
      }

      return obj;
    }, {});

    return Yup.object().shape(schema);
  }, [formItems, isBlocks]);
};

export default useValidationSchema;
